import { EmptyExpr } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotification, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableColumn, PoTableColumnLabel } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Cliente } from 'src/app/interface/cliente';
import { ClienteService } from 'src/app/service/cliente-service';
import { ExcelService } from 'src/app/service/excel-service';
import { UtilService } from 'src/app/service/util';
import { Dano, defaultDano, defaultExpedicaoRomaneioItemPedidoDto, ExpedicaoRomaneioItemPedidoDto } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { FiltroDanos } from '../filter/filtro-controle-danos-lista';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';

@Component({
  selector: 'app-controle-danos-lista',
  templateUrl: './controle-danos-lista.component.html',
  styleUrls: ['./controle-danos-lista.component.css']
})
export class ControleDanosListaComponent implements OnInit {

  etiquetalote: string = '';
  novoPedido: string = '';
  etiquetaExpedicaoPedido: ExpedicaoRomaneioItemPedidoDto;
  retornoDano: Dano;
  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroDanos;

  loteRetorno: Dano;

  advancedDanosFilters: Array<PoDynamicFormField>;
  columnsDanosFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  envLoteLista: Array<any>;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private romaneioService: RomaneioService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    public clienteLookupService: ClienteLookupService,
    private excelService: ExcelService,
    private utilService: UtilService,
  )
  {
    this.tabelaPrincipalFiltro = new FiltroDanos(this.poStorageService);

    this.retornoDano = defaultDano();
    this.loteRetorno = defaultDano();

    this.etiquetaExpedicaoPedido = defaultExpedicaoRomaneioItemPedidoDto();

    this.advancedDanosFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsDanosFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

    this.envLoteLista = [
      { value: 'S', label: 'Sim'},
      { value: 'N', label: 'Não'},
      { value: 'A', label: 'Aguardando'},
    ];

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('criarRegistroModal', { static: true }) criarRegistroModal!: PoModalComponent;
  @ViewChild('dataRetornoModal',{ static: true }) dataRetornoModal!: PoModalComponent;
  @ViewChild('envLoteModal',{ static: true }) envLoteModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.listaDanos(this.tabelaPrincipalFiltro.dados).subscribe((lista)=> {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item, favorite: ['editar','alterarStatus','excluir','etqCliente']};
      });
    })

  }

  public readonly tabelaLiberacaoQualidadeSubtitles: Array<PoTableColumnLabel> = [
    { value: 'A', color: 'color-01', label: 'Aprovado' },
    { value: 'R', color: 'color-05', label: 'Reprovado' },
    { value: '', color: 'color-07', label: '' },
  ];

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    { property: 'CZ03COD'     , label: 'Código'             , width: '100px' },
    { property: 'CZ03LOTE'    , label: 'Lote'               , width: '100px' },
    { property: 'NB8QTDORI'   , label: 'Qtd Orig'           , width: '100px' },
    { property: 'CB1DESC'     , label: 'Produto'            , width: '300px'},
    { property: 'CMOTIVODESC' , label: 'Motivo'             , width: '200px' },
    { property: 'CZ03ENVLOT'  , label: 'Status/Enviado'     , width: '150px', type: 'label',
      labels: [
        { value: 'S', color: 'color-10', label: 'Sim'},
        { value: 'N', color: 'color-07', label: 'Não'},
        { value: 'A', color: 'color-02', label: 'Aguardando'},
      ]
    },
    { property: 'CZ04STATUS', label: 'Lib./Qualid.', visible: true, type: 'label', labels: this.tabelaLiberacaoQualidadeSubtitles },
    { property: 'CRESPONSAVEL', label: 'Responsável por Ações'  , width: '200px' },
    { property: 'CZ03OBS'     , label: 'Observação'             , width: '200px' },
    { property: 'CZ03RETLT'   , label: 'Retorno Lote'           , width: '100px', type: 'label',
      labels: [
        { value: 'N', color: 'color-07', label: 'Nao'},
        { value: 'D', color: 'color-10', label: 'Desmontado'},
        { value: 'S', color: 'color-02', label: 'Sim'},
      ]
    },
    { property: 'CZ03LTRET'   , label: 'Lote de Retorno'    , width: '100px'},
    { property: 'DZ03DTRET'   , label: 'Dt Retorno'    , width: '100px', type: 'date', format: 'dd/MM/yyyy' },
    { property: 'NB8QTDORIRET', label: 'Qtd Retorno'        , width: '100px' },
    { property: 'favorite'    , label: '...'                , width: '150px'  , type: 'icon',
      icons: [
        {
          action: this.editar.bind(this),
          icon: 'po-icon po-icon-calendar-ok',
          tooltip: 'Editar',
          value: 'editar',
          disabled: this.desabilitaDataRetorno.bind(this)
        },
        {
          action: this.alterarStatus.bind(this),
          icon: 'po-icon po-icon-change',
          tooltip: 'Alterar Status',
          value: 'alterarStatus',
          disabled: this.desabilitaDataRetorno.bind(this)
        },
        {
          action: this.ImpEtiq.bind(this),
          icon: 'po-icon po-icon-pdf',
          tooltip: 'Impressao Etiqueta',
          value: 'etqCliente',
        }
      ]

    }
  ]


  ImpEtiq(row: Dano): void {
    this.romaneioService.getEtiquetaDano(row.CZ03COD,row.CZ03LOTE).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ETIQUETA_DANO_${row.CZ03COD.trim()}_${row.CZ03LOTE.trim()}_${new Date().toLocaleString().replace(" ","_")}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  gerarExcel(): void {

    const lista_excel = this.tabelaPrincipalItens.map((item: Dano) => {
      return{
        'Código' : item.CZ03COD,
        'Lote' : item.CZ03LOTE,
        'Produto' : item.CB1COD,
        'Descrição' : item.CB1DESC,
        'Qtd Original' : item.NB8QTDORI,
        'Motivo' : item.CMOTIVODESC,
        'Emissao' : item.DZ03EMISSA ? this.utilService.formataData(item.DZ03EMISSA.toString()) : '' ,
        'Enviar Lote para SOLIDA' : item.CZ03ENVLOT == 'S' ? 'Sim' : item.CZ03ENVLOT == 'N' ? 'Não' : item.CZ03ENVLOT == 'A' ? 'Aguardando' : '' ,
        'Lib. Qualidade' : item.CZ04STATUS == 'A' ? 'Aprovado' : item.CZ04STATUS == 'R' ? 'Reprovado' : '',
        'Responsável por Ações' : item.CRESPONSAVEL,
        'Observacao' : item.CZ03OBS,
        'Retorno Lote' : item.CZ03RETLT,
        'Lote de Retorno' : item.CZ03LTRET,
        'Qtd Retorno' : item.NB8QTDORIRET,
        'Data Retorno' : item.DZ03DTRET ? this.utilService.formataData(item.DZ03DTRET.toString()) : '' ,
        'Obervacao Retorno' : item.CZ03OBSRT,
      }
    })
    this.excelService.exportAsExcelFile(lista_excel, "Controle_Danos")
  }

  editar(row: Dano): void {
    this.retornoDano = row;
    this.dataRetornoModal.open();
  }

  alterarStatus(row: Dano): void {
    this.retornoDano = row;
    this.envLoteModal.open();
  }

  desabilitaDataRetorno(row: Dano): boolean {
    //@ts-ignore
    return row.DZ03DTRET != "" || row.CZ03RETLT == "D" ;
  }

  openDialogconfirmarExclusao(row: Dano): void {
    this.poDialogService.confirm({
      title: 'Excluir Registro',
      message: 'Deseja confirmar a Exclusão?',
      confirm: () => this.excluirDano(row)
    });
  }

  excluirDano(row: Dano): void {
    this.romaneioService.excluirDano(row.CZ03COD).subscribe( () => {
      this.tabelaPrincipalLoad();
    });
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Lista' }
    ]
  };

  public readonly salvarDataAction: PoModalAction = {
    action: () => {
      this.dataRetornoModal.close();
      this.romaneioService.dataRetorno(this.retornoDano).subscribe((ret) => {
        this.poNotificationService.success("Data de Retorno informada com sucesso!");
        this.tabelaPrincipalLoad();
      })
    },
    label: 'Confirmar'
  };

  public readonly salvarEnvLotAction: PoModalAction = {
    action: () => {
      this.envLoteModal.close();
      this.romaneioService.postEnvLotDano(this.retornoDano).subscribe((ret) => {
        this.poNotificationService.success("Campo alterado com sucesso!");
        this.tabelaPrincipalLoad();
      })
    },
    label: 'Confirmar'
  };

  public readonly criarRegistroAction: PoModalAction = {
    action: () => {
      this.criarRegistroModal.close();
      this.redirectNovoCadastro();
    },
    label: 'Confirmar'
  };


  openModalNovoRegistro(): void {
    this.criarRegistroModal.open();
  }

  redirectNovoCadastro(): void {
    if (this.etiquetalote != "") {
      this.router.navigateByUrl(`/estoque/expedicao/danos/cadastro/${this.etiquetalote}`
      )
    } else {
      this.poNotificationService.information("Informe o campo Lote")
    };
  };

  biparEtiqueta(): void {
    if (this.etiquetalote != '') {
      this.romaneioService.consultaTransferenciaExpedicao(this.etiquetalote).subscribe((ret) => {
        this.etiquetaExpedicaoPedido = ret;
      });
      this.etiquetalote = '';
    }
  };

  biparEtiquetaRetorno(): void {
    if (this.retornoDano.CZ03LTRET != '') {
      this.romaneioService.consultaLote2(this.retornoDano.CZ03LTRET).subscribe((ret) => {
        this.loteRetorno = ret;
      });
    }
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };


}
